/**
 * entityVfxAnchor — the SPRITE-CENTER anchor for entity-attached VFX
 * (Follower/Orbiter auras, shields, orbits).
 *
 * `entity.position` is the physics TOP-LEFT (the classic H2000 coordinate
 * gotcha); anchoring auras there parked every persistent buff circle on the
 * character's top-left hitbox corner (DJ's Shield Wall / Avatar / Ice
 * Barrier findings, 2026-06-12). Centering = position + half-size.
 *
 * Mob targets arrive through VFXEffectPlayer.resolveTarget's shim, whose
 * `position` is ALREADY sprite-center (mob.x/y) and which carries no
 * width/height — the half-size term degrades to +0 there, so one formula
 * serves players, remotes, and mobs.
 */
export function entityVfxAnchor(
  target: { position?: { x: number; y: number }; width?: number; height?: number } | null | undefined,
): { x: number; y: number } | null {
  if (!target?.position) return null;
  return {
    x: target.position.x + (target.width ?? 0) / 2,
    y: target.position.y + (target.height ?? 0) / 2,
  };
}
